<div class="custom-breadcrumb" *ngFor="let breadcrumbNode of breadcrumbs$ | async">
    <a
        [routerLink]="breadcrumbNode.getBrowseURL()"
        class="selenium-breadcrumb-subject-link"
        queryParamsHandling="merge"
    >
        {{ breadcrumbNode.title }}
    </a>
</div>
